import { slideToggle, toggleAria } from "../utils.js";
import "core-js/es/array";

export default class Search {
  constructor() {
    this.searchFiltersToggleBtn = document.getElementById(
      "js-toggle-search-filters"
    );
    if (this.searchFiltersToggleBtn) this.bindToggleFilter();
  }

  bindToggleFilter() {
    const searchFilters = document.getElementById("js-searchfilters");

    const filters = document.querySelector(".c-ch-filters__container");

    this.searchFiltersToggleBtn.addEventListener("click", () => {
      slideToggle(this.searchFiltersToggleBtn.nextElementSibling, 200);
      toggleAria(this.searchFiltersToggleBtn, "aria-expanded");
    });
  }
}
